export default {
  title: 'Sites',
  menu: [
    {
      id: 'sites',
      title: 'Sites',
      icon: 'clipboard-list-check',
      style: 'light',
      url: '/#/sites/lista'
    },
    {
      id: 'relatorios',
      title: 'Relatórios',
      icon: 'user-chart',
      style: 'regular',
      url: '#'
    },
    {
      id: 'cadastros',
      title: 'Cadastros básicos',
      icon: 'cog',
      style: 'light',
      url: '/#/cadastro'
    }
  ]
}
